import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
const DashboardDefault2 = Loadable(lazy(() => import('views/dashboard/Default')));
const DashboardDefault = Loadable(lazy(() => import('views/pages/dashboard/')));
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const ForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword')));
const TestLogin = Loadable(lazy(() => import('Components/Auth/GoogleLoginButtonNew')));
const StripeSuccess = Loadable(lazy(() => import('views/pages/StripePayment/Success')));
const StripeError = Loadable(lazy(() => import('views/pages/StripePayment/Cancel')));
const MainRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: <AuthLogin3 />
        },
        {
            path: '/forgot-password/:token',
            element: <ForgotPassword />
        },
        {
            path: '/forgot-password',
            element: <ForgotPassword />
        },
        {
            path: '/test',
            element: <TestLogin />
        },
        {
            path: '/success:token',
            element: <StripeSuccess />
        },
        {
            path: '/error:token',
            element: <StripeError />
        }
    ]
};

// export default MainRoutes;
